import { createContext, useContext, useMemo, useState } from "react";

const ConsentContext = createContext(null);

export function ConsentProvider({ children }) {
  const [consent, setConsentState] = useState(() => localStorage.getItem("cookie_consent"));
  const [prefsOpen, setPrefsOpen] = useState(false);

  const value = useMemo(() => {
    const setConsent = (v) => {
      localStorage.setItem("cookie_consent", v);
      if (v !== "accepted") localStorage.removeItem("visitor_id");
      setConsentState(v);
      setPrefsOpen(false);
    };
    return { consent, setConsent, prefsOpen, setPrefsOpen, openPreferences: () => setPrefsOpen(true) };
  }, [consent, prefsOpen]);

  return <ConsentContext.Provider value={value}>{children}</ConsentContext.Provider>;
}

export const useConsent = () => useContext(ConsentContext);
